<template lang="pug">
.invoices
    h3.invoices__title {{ $t('strings.invoices') }}
    h2.invoices__amount {{ total | currency }}
    vm-table(:data="invoices")
        template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ column.label }}
        template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in invoices")
                vm-td(data="data[indextr][column]" :key="index" v-for="(column, index) in columns" :class="{ 'selected': isSelected(tr) }")
                    div(v-if="column.value != 'amount'" @click="$emit('selected', invoices[indextr])" :style="{ color: color(invoices[indextr]) }") {{ invoices[indextr][column.value] }}
                    div(v-if="column.value == 'amount'" @click="$emit('selected', invoices[indextr])" :style="{ color: color(invoices[indextr]) }") {{ invoices[indextr][column.value]  | currency }}
</template>

<script>
export default {
  name: 'DashboardBreakdownInvoices',
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    selectedInvoices: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    total: function () {
      return this.selectedInvoices
        .reduce((acc, item) => {
          return acc + parseFloat(item.amount)
        }, 0)
        .toFixed(2)
    }
  },
  methods: {
    color (invoice) {
      return parseFloat(invoice.amount_due) >= 0 ? '#ED1C24' : '#1A9746'
    },
    isSelected (invoice) {
      return this.selectedInvoices.length === 1 && this.selectedInvoices[0].id === invoice.id
    }
  }
}
</script>

<style lang="scss">
.invoices {
    &__title {
        font-size: 18px;
        font-weight: 500;
        line-height: 27px;
        letter-spacing: 0em;
        text-align: left;
        color: #929292;
    }

    &__amount {
        font-size: 32px;
        font-weight: 700;
        line-height: 48px;
        letter-spacing: 0em;
        text-align: left;
    }

    .selected {
        background-color: #f2f2f2;
    }
}
</style>
